import $ from "jquery";
window.jQuery = $;
import "jquery.scrollto";
import gsap from "gsap";
import BezierEasing from "bezier-easing";
import stage from "../components/stage";
import render from "../components/render";
require("@fancyapps/fancybox");
import slick from "slick-carousel";

class Page {
  constructor() {
    this.init();
  }

  init() {
    this.addEvents();
    console.log("page.js loaded");
  }

  startPage() {
    this.body = $("body");
    this.addAnimations();
    this.resize();

    this.initSlider();
    this.initFancybox();

    $(".faq__title").click(function () {
      $(this).parent().children(".faq__answer").slideToggle();
    });
  }

  initFancybox() {
    if ($("[data-fancybox]").length) {
      $("[data-fancybox]").fancybox({
        buttons: ["close"],
        loop: false,
        infobar: false,
        animationEffect: "fade",
        transitionEffect: "fade",
      });
    }
  }

  initSlider() {
    if ($(".slick-slider").length) {
      $(".slick-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        fade: true,
        pauseOnHover: true,
        autoplay: true,
        autoplaySpeed: 3000,
      });
    }
  }

  addEvents() {
    this.startPage();
  }

  removeEvents() {}

  addAnimations() {}

  complete() {
    $("html").addClass("initialized");
    this.resize();
  }

  resize(e) {
    if (!e) {
      e = stage;
    }

    this.isMobile = e.w < 768;

    var angle = this.isMobile
      ? this.getAngleDeg(40, stage.w)
      : this.getAngleDeg(200, stage.w);

    $(".bg").each((index, el) => {
      var sign = el.dataset.orientation || -1;
      TweenMax.set(el, { rotation: sign * angle, force3D: true });
    });
  }

  getAngleDeg(a, b) {
    var angleRad = Math.atan(a / b),
      angleDeg = (angleRad * 180) / Math.PI;

    return angleDeg;
  }

  destroy() {
    // console.log('destroy page')
  }
}

module.exports = Page;
